module.exports = __webpack_public_path__ + "static/media/process-get-01.7aa5903f.svg";